import * as yup from 'yup'
export const NO_SPECIAL_CHAR = /^[^!@#$%^&*()+=\\[\]{};:'",.<>?/`~]*$/

export const addPickerMapSchema = yup.object({
  pickerName: yup
    .string()
    .required('Picker name is required field')
    .min(2, 'Picker name must be between 2 and 150 characters.')
    .max(150, 'Picker name must be between 2 and 150 characters.')
    .trim(),
  empId: yup
    .string()
    .required('Employee ID is required field')
    .min(2, 'Employee ID must be between 2 and 100 characters.')
    .max(100, 'Employee ID must be between 2 and 100 characters.')
    .trim(),
})

export const updatePickerMap = yup
  .object({
    _id: yup.string().required(),
  })
  .concat(addPickerMapSchema)

export const updatePickerMapSchema = yup.object({
  mappings: yup.array().of(updatePickerMap).required('Mappings are required'),
})
